// extracted by mini-css-extract-plugin
export default {"root":"style_root__PDU6E","header":"style_header__5lklt","content":"style_content__WAhlx"};